export const ENVD_VERSION_RECURSIVE_WATCH = '0.1.4'
export const ENVD_DEBUG_FALLBACK = '99.99.99'
export const ENVD_COMMANDS_STDIN = '0.3.0'
export const ENVD_DEFAULT_USER = '0.4.0'
export const ENVD_ENVD_CLOSE = '0.5.2'
export const ENVD_OCTET_STREAM_UPLOAD = '0.5.7'
